export default "__VITE_ASSET__BirTpJry__"